module.exports = __webpack_public_path__ + "img/main.f1e239ed.png";